import React from "react";
import PageHeader from "../Components/PageHeader";
import ServiceGallerySection from "./Service/ServiceGallerySection";
import ServicesSection from "./Home/ServiceSection";
import ContactSection from './Home/ContactSection';
import PrintGallerySection from "./Home/PrintGallerySection";
import ClientRateSection from "./Home/ClientRateSection";
import ReviewSection from "./Home/ReviewSection";


const Service = () => {
  return <>

    <PageHeader pageKey="service" />
    <ServicesSection />
    <ServiceGallerySection />
    <ContactSection />
    <PrintGallerySection />
    <ClientRateSection />
    <ReviewSection />

  </>;
};

export default Service;